<div _ngcontent-dyl-c211 class="row">
  <main _ngcontent-dyl-c211 class="col-12 col-md-12 mb-3">
    <h1
      _ngcontent-dyl-c211
      class="uni-heading"
      uni-heading
      color="primary"
      aligntext="center"
      class="mt-1"
      _nghost-dyl-c13
      ng-reflect-color="primary"
      ng-reflect-align-text="center"
    >
      <div _ngcontent-dyl-c13="" class="color-primary font-weight-bold h1 text-center uni-heading">Asociar Usuarios</div>
    </h1>
  </main>
</div>
<div class="container mt-5">
  <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label for="identificacion" class="form-label">Correo</label>
        <input
          type="text"
          class="form-control"
          id="identificacion"
          formControlName="identificacion"
          placeholder="Ingrese correo"
        />
        <div class="text-danger" *ngIf="usuarioForm.get('identificacion')?.invalid && usuarioForm.get('identificacion')?.touched">
          <small *ngIf="usuarioForm.get('identificacion')?.errors?.['required']">Este campo es obligatorio.</small>
          <small *ngIf="usuarioForm.get('identificacion')?.errors?.['email']">Debe ingresar un correo.</small>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label for="codigoUsuario" class="form-label">Número de Identificación</label>
        <input type="text" class="form-control" id="codigoUsuario" formControlName="codUsr" placeholder="Ingrese pasaporte" />
        <div class="text-danger" *ngIf="usuarioForm.get('codUsr')?.invalid && usuarioForm.get('codUsr')?.touched">
          <small>Este campo es obligatorio.</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-12 mb-3 d-flex align-items-end justify-content-end">
        <button uni-button type="submit">Continuar</button>
      </div>
    </div>
  </form>
</div>
